import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { OrangeAccent } from './OrangeAccent';
import { ProgressBar } from './ProgressBar';
export interface QuizOption {
  label: string;
  isDq?: boolean;
}
interface QuizPageProps {
  question: string;
  subline?: string;
  stepNumber: number; // 1..8
  options: QuizOption[];
  onSelect: (option: QuizOption) => void;
}
const KEY_LETTERS = ['A', 'B', 'C', 'D', 'E', 'F'];
export function QuizPage({
  question,
  subline,
  stepNumber,
  options,
  onSelect
}: QuizPageProps) {
  const [selectedIdx, setSelectedIdx] = useState<number | null>(null);
  const handleClick = (opt: QuizOption, idx: number) => {
    if (selectedIdx !== null) return;
    setSelectedIdx(idx);
    window.setTimeout(() => onSelect(opt), 220);
  };
  return <motion.div initial={{
    opacity: 0,
    y: 24
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -24
  }} transition={{
    duration: 0.45,
    ease: [0.16, 1, 0.3, 1]
  }} className="relative overflow-hidden w-full max-w-[680px] bg-white border border-line rounded-[16px] p-6 md:p-11 text-left" data-id="element-113">
      <ProgressBar progress={stepNumber / 8 * 100} data-id="element-114" />
      <div className="font-sans font-bold text-[12px] tracking-widest uppercase text-blue-deep mb-5" data-id="element-115">
        Step {stepNumber} of 8
      </div>

      <h1 className="font-display font-extrabold text-[clamp(26px,4vw,38px)] tracking-tight text-ink leading-[1.15]" data-id="element-116">
        {question}
      </h1>
      <OrangeAccent className="mt-3 mb-6" data-id="element-117" />

      {subline && <p className="font-sans text-[16px] text-ink-soft mb-6 leading-relaxed" data-id="element-118">
          {subline}
        </p>}

      <div className="flex flex-col gap-[10px] mt-2" data-id="element-119">
        {options.map((opt, i) => {
        const isSelected = selectedIdx === i;
        return <button key={opt.label} type="button" onClick={() => handleClick(opt, i)} disabled={selectedIdx !== null && !isSelected} className={['group flex items-center w-full text-left rounded-[10px] border-[1.5px] px-[18px] py-4', 'transition-all duration-200', isSelected ? 'border-orange bg-[rgba(250,70,22,0.07)] translate-x-[3px]' : 'border-line bg-white hover:border-orange hover:bg-[rgba(250,70,22,0.04)] hover:translate-x-[3px]'].join(' ')} data-id="element-120">
              <span className={['flex-shrink-0 w-[26px] h-[26px] rounded-[6px] border flex items-center justify-center mr-[14px]', 'font-sans font-bold text-[12px] transition-colors duration-200', isSelected ? 'bg-orange border-orange text-white' : 'border-line-strong text-ink-soft group-hover:bg-orange group-hover:border-orange group-hover:text-white'].join(' ')} data-id="element-121">
                {KEY_LETTERS[i]}
              </span>
              <span className="font-sans font-medium text-[16px] text-ink leading-snug" data-id="element-122">
                {opt.label}
              </span>
            </button>;
      })}
      </div>
    </motion.div>;
}